import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{
  width?: string | number;
}>()(({ palette, tokens, px }, props) => ({
  root: {
    width: props.width ?? '100%',

    '& .MuiAutocomplete-popupIndicator.Mui-disabled .MuiSvgIcon-root': {
      color: tokens.colors.text.light.tertirary,
    },
  },

  input: {
    '& .MuiInputBase-root': {
      paddingRight: 0,
      lineHeight: 1.5,

      '&.MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
        padding: 0,
        borderRadius: tokens.radius.m,

        '&.MuiInputBase-adornedStart': {
          paddingLeft: tokens.spacing['16'],
        },
      },

      '&.MuiOutlinedInput-root.MuiAutocomplete-inputRoot .MuiInputBase-input': {
        height: px(20),
        paddingTop: tokens.spacing['10'],
        paddingRight: tokens.spacing['24'],
        paddingBottom: tokens.spacing['10'],
        paddingLeft: tokens.spacing['8'],
      },

      '& .MuiSelect-iconOutlined': {
        right: tokens.spacing['16'],
      },

      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: tokens.colors.original.brand.primary,
          borderWidth: tokens.border.s,
        },
      },

      '&.Mui-error': {
        backgroundColor: tokens.colors.accent.bg.error,

        '& fieldset': {
          borderColor: tokens.colors.accent.stroke.error,
        },

        '&.Mui-focused': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: tokens.colors.accent.text.error,
          },
        },

        '&:hover': {
          '& fieldset': {
            borderColor: palette.error.hover,
          },
        },
      },

      '&.Mui-disabled': {
        backgroundColor: tokens.colors.bg.greyscale.secondary,

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: tokens.colors.stroke.primary,
        },
      },

      '& fieldset': {
        borderColor: tokens.colors.stroke.primary,
      },

      '&:hover': {
        '& fieldset': {
          borderColor: tokens.colors.stroke.secondary,
        },
      },

      '& .MuiIconButton-root:hover': {
        backgroundColor: 'transparent',
      },

      '& .MuiAutocomplete-endAdornment': {
        right: tokens.spacing['16'],

        '& .MuiAutocomplete-clearIndicator': {
          backgroundColor: 'transparent',

          '& .MuiTouchRipple-root': {
            display: 'none',
          },
        },
      },
    },

    '& .MuiFormHelperText-root.Mui-error': {
      marginLeft: 0,
      marginRight: 0,
    },
  },

  searchIcon: {
    color: tokens.colors.text.light.tertirary,
  },

  list: {
    boxShadow: tokens.shadow.l,
    overflowY: 'hidden',
    marginRight: 0,
    marginLeft: 0,
    marginTop: tokens.spacing['4'],
    marginBottom: tokens.spacing['4'],

    '& .MuiAutocomplete-noOptions': {
      padding: 0,
    },
  },

  listBox: {
    display: 'grid',
    gap: tokens.spacing['4'],
    paddingTop: tokens.spacing['12'],
    paddingBottom: tokens.spacing['12'],
    maxHeight: '650px',
    overflow: 'auto',
  },

  option: {
    fontSize: tokens.typography.variant.body3.fontSize,
    lineHeight: tokens.typography.variant.body3.lineHeight,
    paddingTop: '0!important',
    paddingRight: '8px!important',
    backgroundColor: 'unset!important',
    paddingBottom: '0!important',
    paddingLeft: '8px!important',
    cursor: 'pointer',

    '&:hover > *': {
      backgroundColor: tokens.colors.bg.greyscale.secondary,
      borderRadius: tokens.radius.m,
    },

    '&[aria-disabled="true"]': {
      opacity: 'unset!important',
      backgroundColor: 'unset!important',
      cursor: 'default!important',
      pointerEvents: 'auto!important' as 'auto',

      '&:hover > *': {
        backgroundColor: 'unset!important',
      },
    },
  },
}));
